import Error from '../model/Error';
import SectionRelation from '../dto/SectionRelation';
import axios from 'axios';
import moment from 'moment';

export default class SectionRelationRepository {
    static findAll(kindergartenId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/kindergartens/${kindergartenId}/section-relations`)
                .then((response) => resolve(response.data.data.map((data) => SectionRelation.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static create(kindergartenId, sectionId, start, end) {
        return new Promise((resolve, reject) => {
            axios
                .post('/section-kindergarten-relations', {
                    kindergartenId,
                    sectionId,
                    start: moment(start, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                    end: end ? moment(end, 'DD.MM.YYYY').format('YYYY-MM-DD') : null,
                })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static remove(sectionRelationId) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/section-kindergarten-relations/${sectionRelationId}`)
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static update(sectionRelations) {
        return Promise.all(sectionRelations.map((sectionRelation) => {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/section-kindergarten-relations/${sectionRelation.id}`, {
                        start: moment(sectionRelation.start, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                        end: sectionRelation.end ? moment(sectionRelation.end, 'DD.MM.YYYY').format('YYYY-MM-DD') : null,
                    })
                    .then(() => resolve())
                    .catch((error) => reject(Error.fromResponse(error.response)));
            });
        }));
    }
}
